export const inputStyles = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    margin: 5,
    '& .ms-TextField-fieldGroup': {
      maxWidth: 94,
    },
  },
};

export const labelStyles = {
  root: {
    display: 'inline-flex',
  },
};

